import { render } from "./AgentFiles.vue?vue&type=template&id=51c30a08&scoped=true&ts=true"
import script from "./AgentFiles.vue?vue&type=script&lang=ts"
export * from "./AgentFiles.vue?vue&type=script&lang=ts"

import "./AgentFiles.vue?vue&type=style&index=0&id=51c30a08&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51c30a08"]])

export default __exports__